// extracted by mini-css-extract-plugin
export default {"heatMapContainer":"ticket-heatmap_heatMapContainer__XbNAb","heatMap":"ticket-heatmap_heatMap__cQBxo"};